import { MdOutlineCheck } from "react-icons/md";

import { formatToPersianClock, formatToPersianDate } from "../../../../utils";
import PersianNumber from "../../../../utils/PersianNumber/PersianNumber";

const AdminLiveMobileView = ({ getLiveOrders, handleChangeOrderType }) => {
  return (
    <>
      <div className="my-16 animate__animated animate__fadeIn animate__slow">
        {/* Data */}
        {getLiveOrders?.map((_item, index) => (
          <div
            key={index}
            className="w-full h-full rounded-xl bg-boxColor relative 
            py-4 animate__animated animate__fadeIn animate__slow"
          >
            <span
              className="flex flex-col justify-center items-center w-full
              animate__animated animate__flipInX animate__fast"
            >
              {/* Data Box */}
              <div className="space-y-3 font-medium text-base w-full">
                {/* Title */}
                <span
                  className={`${
                    _item?.bos === "B" ? "text-[#00FF00]" : "text-[#FF073A]"
                  } font-medium text-lg w-full flex justify-center`}
                >
                  <span>معامله</span>
                  <span className="px-1">
                    {_item?.bos === "B" ? "خرید" : "فروش"}{" "}
                  </span>
                  <span className="text-gray-100">{_item?.product_name}</span>
                </span>
                {/* Items */}
                <span className="grid grid-cols-2 w-full px-3 tracking-wide">
                  {/* Right Column */}
                  <ul className="flex flex-col text-right w-full text-gray-200 space-y-5">
                    {/* Transaction ID */}
                    <li>
                      <span>شماره سفارش</span>
                    </li>
                    {/* User Name */}
                    <li>
                      <span>کاربر</span>
                    </li>
                    {/* Order Status */}
                    <li>
                      <span>وضعیت</span>
                    </li>
                    {/* Weight */}
                    <li>
                      <span className="flex">
                        حجم
                        <p className="text-xs px-1 flex items-center text-[#00BFFF]">
                          ( {_item.tag === "S" ? "تعداد" : "مقدار (گرم)"} )
                        </p>
                      </span>
                    </li>
                    {/* Price */}
                    <li>
                      <span className="flex">
                        قیمت
                        <p className="text-xs px-1 flex items-center text-[#00BFFF]">
                          ( تومان )
                        </p>
                      </span>
                    </li>
                    {/* Total */}
                    <li>
                      <span className="flex">
                        مبلغ
                        <p className="text-xs px-1 flex items-center text-[#00BFFF]">
                          ( تومان )
                        </p>
                      </span>
                    </li>
                    {/* Description */}
                    <li>
                      <span>توضیحات</span>
                    </li>
                    {/* Ordery Status */}
                    <li>
                      <span>اردری</span>
                    </li>
                    {/* Date */}
                    <li>
                      <span>تاریخ</span>
                    </li>
                  </ul>
                  {/* Left Column */}
                  <ul className="flex flex-col text-left w-full text-gray-50 space-y-5">
                    {/* Transaction ID */}
                    <li>
                      <span>#{_item?.transaction_id}</span>
                    </li>
                    {/* User Name */}
                    <li>
                      <span>{_item.customeruser}</span>
                    </li>
                    {/* Order Status */}
                    <li>
                      {_item?.tType === "T" ? (
                        <span className="text-[#00FF00] cursor-pointer">
                          تأیید شده
                        </span>
                      ) : _item?.tType === "L" ? (
                        <>
                          <span className="text-[#FF073A] cursor-pointer">
                            لغو شده
                          </span>
                        </>
                      ) : (
                        <>
                          <span className="text-gray-100">-</span>
                        </>
                      )}
                    </li>
                    {/* Weight */}
                    <li>
                      <span>
                        <PersianNumber
                          value={_item?.volume}
                          thousandSeparator=","
                        />
                      </span>
                    </li>
                    {/* Price */}
                    <li>
                      <span className="flex justify-end">
                        <PersianNumber
                          value={_item?.price}
                          thousandSeparator=","
                        />
                      </span>
                    </li>
                    {/* Total */}
                    <li>
                      <span className="flex justify-end">
                        <PersianNumber
                          value={_item?.amount}
                          thousandSeparator=","
                        />
                      </span>
                    </li>
                    {/* Description */}
                    <li>
                      <span>
                        {_item?.description ? (
                          <>{_item?.description}</>
                        ) : (
                          <span className="text-slate-300">-</span>
                        )}
                      </span>
                    </li>
                    {/* Ordery Status */}
                    <li>
                      <span className="flex justify-end">
                        {_item?.is_orderi ? (
                          <MdOutlineCheck size={26} fill="#00BFFF" />
                        ) : (
                          <span className="text-slate-300">-</span>
                        )}
                      </span>
                    </li>
                    {/* Date */}
                    <li>
                      <span className="flex flex-col justify-center items-end space-y-1">
                        <span>{formatToPersianClock(_item?.date_create)}</span>
                        <span>{formatToPersianDate(_item?.date_create)}</span>
                      </span>
                    </li>
                  </ul>
                </span>
                {/* Button */}
                <div className="flex w-full justify-center items-center pt-3">
                  <span
                    className="w-6/12 flex justify-center items-center
                    font-medium text-sm tracking-wide text-gray-100"
                  >
                    <button
                      onClick={() => handleChangeOrderType(_item.id, "L")}
                      className="hover:bg-red-600 border-2 border-red-600
                      mx-5 rounded-xl px-5 py-1 transition-all ease-linear
                      duration-100 hover:transition-all hover:ease-linear hover:duration-100"
                    >
                      لغو
                    </button>
                    <button
                      onClick={() => handleChangeOrderType(_item.id, "T")}
                      className="hover:bg-green-600 border-2 border-green-600
                      mx-5 rounded-xl px-5 py-1 transition-all ease-linear
                      duration-100 hover:transition-all hover:ease-linear hover:duration-100"
                    >
                      تأیید
                    </button>
                  </span>
                </div>
              </div>
              {/* Divide Line */}
              <span className="w-full border-b-[1px] border-boxColor" />
            </span>
          </div>
        ))}
      </div>
    </>
  );
};

export default AdminLiveMobileView;
